import { HERO } from "../data";
import Reveal from "./Reveal";

export default function Hero({ onNavigate }) {
  return (
    <section id="hero" className="relative overflow-hidden pt-16 pb-12 sm:pt-24 sm:pb-16">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-64 w-64 -translate-x-1/2 rounded-full bg-slate-700/30 blur-3xl" />
      </div>

      <Reveal className="mx-auto max-w-4xl px-4 sm:px-6">
        {/* Inner card — py-14 was an excessively tall base on 320px screens;
            sm:py-18 was an invalid Tailwind class that generated no CSS.
            Both are corrected to explicit valid values. */}
        <div className="relative overflow-hidden rounded-[2rem] border border-slate-800/90 bg-slate-950/95 px-5 py-10 shadow-[0_35px_120px_-80px_rgba(15,23,42,0.9)] sm:px-10 sm:py-14">
          <div className="space-y-5 text-center sm:text-left">
            {/* Badge — narrowed tracking prevents overflow on 320px */}
            <div className="mx-auto inline-flex rounded-full border border-slate-700/70 bg-slate-900/80 px-3 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-300 sm:mx-0 sm:tracking-[0.28em]">
              {HERO.badge}
            </div>

            <div className="space-y-2">
              <h1 className="text-3xl font-black tracking-tight text-slate-100 sm:text-5xl md:text-6xl">
                {HERO.firstName}{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-400 to-cyan-400">
                  {HERO.lastName}
                </span>
              </h1>
              <p className="text-base font-semibold leading-snug text-slate-300 sm:text-xl sm:leading-tight">
                {HERO.title}
              </p>
            </div>

            <p className="mx-auto max-w-xl text-sm leading-6 text-slate-400 sm:mx-0 sm:text-base sm:leading-7">
              {HERO.description}
            </p>

            {/* CTAs — stack on mobile, row on sm+ */}
            <div className="flex flex-col gap-3 sm:flex-row sm:justify-start">
              <button
                type="button"
                onClick={() => onNavigate("Projects")}
                className="inline-flex min-h-[48px] w-full items-center justify-center rounded-full bg-gradient-to-r from-fuchsia-500 to-cyan-400 px-6 py-3 text-sm font-bold text-slate-950 transition-opacity duration-200 hover:opacity-90 active:opacity-80 focus:outline-none focus:ring-2 focus:ring-fuchsia-400/60 sm:w-auto"
              >
                View Projects
              </button>
              <button
                type="button"
                onClick={() => onNavigate("Contact")}
                className="inline-flex min-h-[48px] w-full items-center justify-center rounded-full border border-slate-700 bg-slate-900/90 px-6 py-3 text-sm font-semibold text-slate-200 transition-colors duration-200 hover:border-slate-600 hover:bg-slate-900 active:bg-slate-800 sm:w-auto"
              >
                Resume / Contact
              </button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
